import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { RichTextArea } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../../hocs/with-anchor.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../../hooks/use-bloomreach-rich-text.js';
import '../../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../../hocs/with-breakpoint-visibility.js';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowText = ({ component , page  })=>{
    var ref;
    const _ref = component === null || component === void 0 ? void 0 : component.getParameters(), { horizontalAlignment , verticalAlignment  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "horizontalAlignment",
        "verticalAlignment"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const { document: documentRef  } = component.getModels();
    const document = page === null || page === void 0 ? void 0 : page.getContent(documentRef);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    const richText = useBloomreachRichText((ref = content.content) === null || ref === void 0 ? void 0 : ref.value);
    const rowTextClassName = generateConditionalClassNames('br-row-text', {
        horizontalAlignment,
        verticalAlignment
    });
    if (!content || !richText) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: rowTextClassName,
        "data-t": "br-row-text",
        style: filteredStyles
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: richText
    }));
};
var RowText = compose(withBreakpointVisibility, withAnchor)(CmsRowText);

export { CmsRowText, RowText as default };
//# sourceMappingURL=RowText.js.map
